var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paypal",class:{'is-disabled': _vm.disabled}},[(!_vm.scriptLoaded)?_c('div',[_vm._v("Loading...")]):_vm._e(),_c('div',{attrs:{"id":"paypal-button-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }